import React, { useState } from 'react';
import {
  Paper,
  Typography,
  TextField,
  Box,
  Button,
  Collapse,
  IconButton,
  Alert,
} from '@mui/material';
import { PlayArrow, Stop, ExpandMore, ExpandLess } from '@mui/icons-material';

const MatchTimer = ({ timer, currentHalf, setTimer, setCurrentHalf, timerRunning, setTimerRunning }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [showAlert, setShowAlert] = useState(false);

  const toggleTimer = () => {
    if (!timerRunning) {
      // Starting the timer - show alert
      setShowAlert(true);
      setTimerRunning(true);
    } else {
      // Stopping the timer - hide alert
      setShowAlert(false);
      setTimerRunning(false);
    }
  };

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: collapsed ? 0 : 3 }}>
        <Typography variant="h5" component="h2">
          Match Timer
        </Typography>
        <IconButton onClick={toggleCollapse} size="small">
          {collapsed ? <ExpandMore /> : <ExpandLess />}
        </IconButton>
      </Box>

      <Collapse in={!collapsed}>
        {showAlert && (
          <Alert severity="info" sx={{ mb: 2 }}>
            Match timer is now active! Times will be automatically populated when adding substitutions and notes.
          </Alert>
        )}

        {/* Timer Section */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Typography variant="h6">
            Time: {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')}
          </Typography>
          <TextField
            label="Correct Time (min)"
            type="number"
            value={Math.floor(timer / 60)}
            onChange={(e) => setTimer(Math.max(0, e.target.value) * 60)}
            sx={{ width: 150 }}
            inputProps={{ min: 0 }}
          />
          <Button
            variant={timerRunning ? "outlined" : "contained"}
            color={timerRunning ? "error" : "success"}
            startIcon={timerRunning ? <Stop /> : <PlayArrow />}
            onClick={toggleTimer}
          >
            {timerRunning ? 'Stop Timer' : 'Start Timer'}
          </Button>
        </Box>
      </Collapse>
    </Paper>
  );
};

export default MatchTimer;